module.exports = __webpack_public_path__ + "img/expand-min.3f3640e6.png";